import React from "react";
import { useTranslation } from "react-i18next";
import PrivacyIcon from "../Images/Privacy_icon.svg";
import "./Privacy.scss";
import Animation from "../Animation/Animation";

export const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div
      className="justify-center pt-10 pb-14"
      // style={{
      //   background:
      //     "linear-gradient(90deg, #E6D7FF 0%, rgba(230, 215, 255, 0.53) 0.01%, rgba(155, 141, 184, 0.73) 100.4%, rgba(75, 62, 108, 0) 70%)",
      // }}
    >
      <div className="flex-col">
        {/* <img
          className=" "
          src={PrivacyIcon}
          alt="Privacy icon"
          style={{
            width: "70px",
            //   display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        /> */}
        <Animation/>

        <div className="text-white text-[46px] font-geo wow fadeInUp font-semibold privacy">
          {t("privacy.title")}
        </div>
      </div>

      <div className="flex justify-center font-medium font-sans wow fadeInUp lg:mx-36">
        <div className="text-gray-200 text-center text-xl mt-4 mx-4">
          {t("privacy.description")}
        </div>
      </div>
    </div>
  );
};
